interface props {
  children: string;
  handleChange?: Function;
  id: string;
  reduxData: {
    _id: string,
    title: string
  }[];
  useSlug?: boolean; // New prop to enable slug-based comparison
}

export function FilterItem({ id, children, handleChange, reduxData, useSlug = false }: props) {

  const handleToggle = () => {
    handleChange && handleChange({ _id: id, title: children })
  };

  // Check if item is selected using slug (for features) or _id (for other filters)
  const isChecked = useSlug
    ? reduxData?.some((item) => {
      const itemSlug = `${item._id}_${item.title}`;
      const currentSlug = `${id}_${children}`;
      return itemSlug === currentSlug;
    })
    : reduxData?.some((item) => item._id === id);

  return (
    <li
      className="list-none text-left p-2 flex items-center gap-2 font-medium text-sm cursor-pointer hover:bg-gray-50"
      onClick={handleToggle}
    >
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
        onClick={(e) => e.stopPropagation()}
      />
      <label className="cursor-pointer flex-1">{children}</label>
    </li>
  );
}
